import { Route, Routes } from 'react-router-dom'
import { hsDetailsRoutes } from './routes'
import { GeneralDetails } from './General/GeneralDetails'

export const ViewEditHSRouter = () => (
  <Routes>
    {hsDetailsRoutes.map((route) => (
      <Route key={route.path} path={route.path} element={<route.component />} />
    ))}
    <Route index element={<GeneralDetails />} />
  </Routes>
)
